import React, { useEffect, useState } from "react";
import {
    apiConstants,
    get,
    getDownload,
    postMultipart,
} from "../../common/constants";
import {
    FormProvider,
    RHFFileField,
} from "../../common/hook-form";
import { useForm } from "react-hook-form";
// import * as Yup from "yup";
import {
    Box,
    Button,
    Grid,
    Link,
    Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
// import { yupResolver } from "@hookform/resolvers/yup";
import {
    formatDate,
    // yupFileValidation,
} from "../../helpers/UtilityHelper";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// import { DataGrid } from "@mui/x-data-grid";
import ProzoDataGrid from "../../common/ProzoDataGrid";
import MUIModal from "../../common/MUIModal";
import { primaryTextSx, secondaryTextSx, cellStackSx } from '../orders/list2/cellStyles';
import { FONT, SIZE } from '../../styles/foundation/typography';
import { filterBarSx, primaryBtnSx, secondaryBtnSx } from '../../styles/patterns';
import { SUBTLE } from '../../styles/foundation/colors';
import { FileDownloadOutlined } from "@mui/icons-material";
import { useSnackbar } from "notistack";
import { getMerchant, getToken } from "../../helpers/ReduxHelpers";
import jwt_decode from "jwt-decode";
import CopyIcon from "../../common/CopyIcon";


const NDRBulkUpload = () => {
    // const { data: allCouriers } = useGetCouriersQuery();
    const [isUploadingFile, setIsUploadingFile] = useState(false);
    const [errorMsg, setErrorMsg] = useState()
    const [dataa, setData] = useState([])
    const [page, setPage] = useState(0);
    const methods = useForm();
    const [sizePerPage, setSizePerPage] = useState(10);
    const [page1, setPage1] = useState(0);
    const [sizePerPage1, setSizePerPage1] = useState(10);
    const [reload, setReload] = useState(0)
    const [seeOrders, setSeeOrders] = useState(false)
    const [orderData, setOrderData] = useState([])
    const { enqueueSnackbar } = useSnackbar()
    const { piiAccessAllow } = jwt_decode(getToken());

    // const methodsBulkUpload = useForm({
    //     resolver: yupResolver(
    //         Yup.object().shape({
    //             ndrFile: Yup.mixed().required("Please Select a File"),
    //         })
    //     ),
    //     defaultValues: {
    //         ndrFile: ''
    //     }
    // });
    const { handleSubmit: handleSubmitBulkUpload, reset: resetForm } = methods;

    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''

    const onSubmitBulkUpload = async (data) => {
        setIsUploadingFile(true);
        try {
            let form = new FormData();
            form.append("file", data.ndrFile[0])
            form.append("remark", 'NDR Bulk Upload')
            await postMultipart(`${apiConstants.NDR_BULK_UPLOAD}?merchantOid=${merchantId}`, form).then((res) => {
                setIsUploadingFile(false)
                if (res.status === 200) {
                    if (res.data && res.data?.status === 'ERROR') {
                        enqueueSnackbar("File Upload Failed", { variant: "error" });
                        setErrorMsg(res.data?.errorMsg)
                        setIsUploadingFile(false)
                    } else {
                        enqueueSnackbar("Successfully Uploaded!", { variant: "success" });
                        setIsUploadingFile(false)
                    }
                    // setResult(res?.data?.responseObj)
                }
            })
            setReload(reload + 1);
            setIsUploadingFile(false)
            resetForm()
            // navigate("/orders");
        } catch (err) {
            const message = err?.response?.data?.message || err.message;
            enqueueSnackbar(message || "Error uploading file", { variant: "error" });
            setIsUploadingFile(false)
        }
        resetForm({
            ndrFile: ''
        })
        setIsUploadingFile(false);
    };


    const handleBulkSample = () => {
        getDownload(
            `${apiConstants.BASE_LOCAL}${apiConstants.DOWNLOAD_SAMPLE_LOCATION}?fileName=NDR_BULK_ACTION_V2`
        )
            .then((response) => {
                const binaryData = [];
                binaryData.push(response.data);
                const href = URL.createObjectURL(
                    new Blob(binaryData, { type: "application/octet-stream" })
                );
                const link = document.createElement("a");
                link.href = href;
                link.setAttribute("download", "bulk-upload-sample.csv");
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            })
            .catch((err) => {
                console.error(err);
            });
    };

    useEffect(() => {
        get(`${apiConstants.BASE_LOCAL}${apiConstants.GET_BULK_UPLOAD_NDR}?merchantOid=${merchantId}`).then((res) => {
            setData(res?.data?.responseObj)
        })
    }, [reload])

    const columnsOrderModal = [
        {
            field: "awb",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "AWB",
            flex: 0.7,
            minWidth: 140,
            renderCell: (params) => {
                const { row } = params;
                return row?.data?.awbNumber ? <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>{row.data.awbNumber}<CopyIcon text={row.data.awbNumber} /></span> : ''

            },
        },
        {
            field: "action",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "NDR Action",
            flex: 0.7,
            minWidth: 120,
            renderCell: (params) => {
                const { row } = params;
                return row?.data?.action

            },
        },
        {
            field: "remark",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Remark",
            flex: 2,
            minWidth: 200,
            renderCell: (params) => {
                const { row } = params;
                return row?.response?.remark

            },
        },
        {
            field: "actionBy",
            headerAlign: "center",
            hideSortIcons: true,
            headerName: "Action User",
            flex: 1,
            minWidth: 140,
            renderCell: (params) => {
                const { row } = params;
                return row?.data?.actionedBy

            },
        },
    ];

    const columns = [
        {
            field: 'id', headerAlign: "center", hideSortIcons: true, headerName: 'Id', flex: 1.2, minWidth: 200
        },
        ...(piiAccessAllow ? [{
            field: 'file', headerAlign: "center", hideSortIcons: true, headerName: 'Uploaded File', flex: 1, minWidth: 120,
            align: 'center', renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        <Link href={row?.s3RefToFile?.signedLink} target="_blank" rel='noreferrer' style={{ color: 'black', textDecoration: 'underline', cursor: 'pointer' }}>File</Link>
                    </>
                )
            },
        },] : []),

        {
            field: 'fileProgress', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Status', flex: 1, minWidth: 120
        },
        {
            field: 'createdAt', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Upload Date', width: 150, minWidth: 150, renderCell: (params) => {
                const { row } = params;
                return (
                    <>
                        {formatDate(row?.createdAt)}
                    </>
                )
            },
        },
        {
            field: 'totalRecords', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Upload Status', flex: 1.2, minWidth: 180, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}>
                            Total Shipments: {row?.executionStatus?.totalTasks}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            Failed Shipments: {row?.executionStatus?.failed}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            Successful Shipments: {row?.executionStatus?.success}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'successOrders', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Successful Orders', flex: 1, minWidth: 140, renderCell: (params) => {
                const { row } = params;
                if (row?.executionStatus?.success > 0) {
                    return (
                        <Box sx={cellStackSx}>
                            <Button
                                sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0 }}
                                onClick={() => {
                                    const flattenedArray = [].concat(...row?.taskListBatch);
                                    let k = flattenedArray?.filter((item) => item?.status === "SUCCESS");
                                    setOrderData(k);
                                    setSeeOrders(true);
                                }}
                            >
                                View Details
                            </Button>
                            <Typography sx={secondaryTextSx}>
                                Successful Shipments : {row?.executionStatus?.success}
                            </Typography>
                        </Box>
                    )
                }
                else {
                    return ("-")
                }
            },
        },
        {
            field: 'failedOrders', align: 'center', headerAlign: "center", hideSortIcons: true, headerName: 'Failed Orders', flex: 1, minWidth: 140, renderCell: (params) => {
                const { row } = params;
                if (row?.executionStatus?.failed > 0) {
                    return (
                        <Box sx={cellStackSx}>
                            <Button
                                sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', p: 0, minWidth: 0 }}
                                onClick={() => {
                                    const flattenedArray = [].concat(...row?.taskListBatch);
                                    let k = flattenedArray?.filter((item) => item?.status !== "SUCCESS");
                                    setOrderData(k);
                                    setSeeOrders(true);
                                }}
                            >
                                View Details
                            </Button>
                            <Typography sx={secondaryTextSx}>
                                Failed Shipments : {row?.executionStatus?.failed}
                            </Typography>
                        </Box>
                    )
                }
                else {
                    return ("-")
                }
            },
        }
    ]

    return (
        <>
            <Box>
                <Box sx={filterBarSx}>
                    <FormProvider
                        methods={methods}
                        onSubmit={handleSubmitBulkUpload(onSubmitBulkUpload)}
                    >
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <RHFFileField required={true} fileType={['csv']} name="ndrFile" label="Click here to upload. Maximum 500 NDR actions can be uploaded in one file." accept={["csv"]} />
                            </Grid>
                            <Grid item xs={12} sm={5}>
                                <LoadingButton
                                    startIcon={<FileUploadIcon />}
                                    type="submit"
                                    loading={isUploadingFile}
                                    sx={primaryBtnSx}
                                    size="small"
                                >
                                    Upload
                                </LoadingButton>
                                <Button
                                    sx={{ ...secondaryBtnSx, ml: 1 }}
                                    size="small"
                                    startIcon={<FileDownloadOutlined />}
                                    onClick={() => handleBulkSample()}
                                >
                                    Sample Download
                                </Button>
                            </Grid>
                            {errorMsg && errorMsg !== '' && (
                                <Grid item xs={12} sm={12} sx={{ justifyContent: 'right' }}>
                                    <Typography sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], color: '#d32f2f' }}>{"0 records succeeded. Error details : " + errorMsg + " . Please make changes to the file and reupload. "}</Typography>

                                </Grid>
                            )}
                        </Grid>
                    </FormProvider>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <ProzoDataGrid
                        columns={columns}
                        rows={dataa.length > 0 ? dataa : []}
                        sizePerPage={sizePerPage}
                        setSizePerPage={setSizePerPage}
                        setPage={setPage}
                        page={page}
                        pagination={true}
                        hideFooterPagination={false}
                        filterMode={"server"}
                        paginationMode={'client'}
                        rowCount={dataa?.length}
                        getRowId={(row) => row.id}
                    />
                </Box>
            </Box>

            <MUIModal
                open={seeOrders}
                title="AWB Details"
                maxWidth={"lg"}
                handleClose={() => setSeeOrders(false)}
            >
                <ProzoDataGrid
                    // autoHeight={false}
                    sizePerPage={sizePerPage1}
                    setSizePerPage={setSizePerPage1}
                    page={page1}
                    setPage={setPage1}
                    rowCount={orderData?.length}
                    columns={columnsOrderModal}
                    rows={orderData}
                    paginationMode={'client'}
                    pagination={true}
                    hideFooterPagination={false}
                    getRowId={(row) => Math.random()}
                />
            </MUIModal>
        </>

    );
};
export default NDRBulkUpload;
